module.exports = __webpack_public_path__ + "img/bookBorder.02f1f140.png";